// extracted by mini-css-extract-plugin
export default {"input":"InputNumberStyles_input__dSa4u","labelInputMobilePhone":"InputNumberStyles_labelInputMobilePhone__zhCQ6","label":"InputNumberStyles_label__Mojcm"};